import { Skeleton } from '@nextui-org/react';

const CollectionSkeletion = () => {
  const arr = Array.from(Array(15).keys());

  return (
    <div className="grid grid-cols-5 gap-5 2xl:grid-cols-4 xl:grid-cols-3 lg:grid-cols-2 sm:grid-cols-1">
      {arr.map((item) => (
        <Skeleton key={item} className="h-[370px] rounded-[32px]" />
      ))}
    </div>
  );
};

export default CollectionSkeletion;
